import React, { Component } from 'react'
import $ from 'jquery'

import images from '../../../config/images'
import '../../../stylesheets/press.css'

class Press extends Component {
  componentDidMount() {
    scrollUpdate()

    $(window).scroll(function() {
      scrollUpdate()
    })

    function scrollUpdate() {
      if ($('#PRESS_PAGE').length) {
        //Window Variables
        var windowTop = $(window).scrollTop()
        var windowHeight = $(window).height()
        var windowBottom = windowTop + windowHeight

        //Header Text
        var news = $('#press')
        var newsBottom = news.offset().top + news.outerHeight() * 0.5

        if (windowBottom > newsBottom) {
          news.addClass('fade-in')
        }

        //sheridan
        var sheridan = $('#sheridan')
        var sheridanBottom = sheridan.offset().top + sheridan.outerHeight() * 0.5

        if (windowBottom > sheridanBottom) {
          sheridan.addClass('fade-in')
        }

        //gala
        var gala = $('#gala')
        var galaBottom = gala.offset().top + gala.outerHeight() * 0.5

        if (windowBottom > galaBottom) {
          gala.addClass('fade-in')
        }

        //GIGI's
        var gigi = $('#gigi')
        var gigiBottom = gigi.offset().top + gigi.outerHeight() * 0.5

        if (windowBottom > gigiBottom) {
          gigi.addClass('fade-in')
        }

        //defender
        var defender = $('#defender')
        var defenderBottom = defender.offset().top + defender.outerHeight() * 0.5

        if (windowBottom > defenderBottom) {
          defender.addClass('fade-in')
        }

        //morning
        var morning = $('#morning')
        var morningBottom = morning.offset().top + morning.outerHeight() * 0.5

        if (windowBottom > morningBottom) {
          morning.addClass('fade-in')
        }

        //windy
        var windy = $('#windy')
        var windyBottom = windy.offset().top + windy.outerHeight() * 0.5

        if (windowBottom > windyBottom) {
          windy.addClass('fade-in')
        }

        //morning2
        var morning2 = $('#morning2')
        var morning2Bottom = morning2.offset().top + morning2.outerHeight() * 0.5

        if (windowBottom > morning2Bottom) {
          morning2.addClass('fade-in')
        }

        //morning3
        var morning3 = $('#morning3')
        var morning3Bottom = morning3.offset().top + morning3.outerHeight() * 0.5

        if (windowBottom > morning3Bottom) {
          morning3.addClass('fade-in')
        }

        //sports
        var sports = $('#sports')
        var sportsBottom = sports.offset().top + sports.outerHeight() * 0.5

        if (windowBottom > sportsBottom) {
          sports.addClass('fade-in')
        }

        //comcast
        var comcast = $('#comcast')
        var comcastBottom = comcast.offset().top + comcast.outerHeight() * 0.5

        if (windowBottom > comcastBottom) {
          comcast.addClass('fade-in')
        }
      }
    }
  }

  render() {
    return (
      <div id="PRESS_PAGE">
        {/* Content */}
        <header className="header" id="header">
          <img
            src={images.press_header}
            alt="background"
            width="100%"
            height="100%"
            className="header-img"
          />
          <div className="header-txt" id="press">
            <h1>PRESS</h1>
            <p>
              For press inquiries or to schedule an interview with one of our members/players,
              please contact
              <a href="mailto:tom.serpento@rpfpc.com">Tom Serpento</a>.
            </p>
            <br />
          </div>
        </header>
        <div className="story section" id="gala">
          <h3>
            Gala raises $600,000 for Gigi's Playhouse.
            <div className="underline" />
          </h3>
          <h4>5-10-2017</h4>
          <div className="column left">
            <a
              href="http://www.chicagotribune.com/suburbs/hinsdale/lifestyles/ct-bcr-faces-gigigallery-tl-0421-20170421-photogallery.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={images.pressImages.ct_tlh_ct_evr_trend_gigigala_tl_0420_11_jpg_20170421}
                alt="Gigi Gala"
              />
            </a>
          </div>
          <div className="column right">
            <p>
              Nancy Gianni of South Barrington, center, GiGi’s Playhouse founder and president, with
              former NFL players at the 2017 GiGi’s Playhouse Chicagoland gala
            </p>
            <a
              href="http://www.chicagotribune.com/suburbs/hinsdale/lifestyles/ct-bcr-faces-gigigallery-tl-0421-20170421-photogallery.html"
              target="_blank"
              rel="noopener noreferrer"
              className="button"
            >
              MORE IMAGES
            </a>
          </div>
        </div>
        <div className="story section" id="sheridan">
          <h3>
            Sheridan Road Charitable Foundation
            <div className="underline" />
          </h3>
          <h4>5-8-2017</h4>
          <div className="column left">
            <a
              href="http://jwcdaily.com/sheridanroadmagazine/2017/05/08/sheridan-road-charitable-foundation/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={images.pressImages.sheridan_news} alt="Sheridan News" />
            </a>
          </div>
          <div className="column right">
            <p>
              Football fans spent an intimate evening meeting members of the Retired Professional
              Football Players of Chicago.
              <a href="http://www.srcfoundation.com">Foundation</a>
              President Daniel Bryant announced a partnership between his foundation, the Sanfilippo
              Family Foundation, and the NFL Players Association Charities, benefitting under
              resourced children throughout Chicagoland.
            </p>
            <a
              href="http://jwcdaily.com/sheridanroadmagazine/2017/05/08/sheridan-road-charitable-foundation/"
              target="_blank"
              rel="noopener noreferrer"
              className="button"
            >
              FULL ARTICLE
            </a>
          </div>
        </div>
        <div className="story section" id="gigi">
          <h3>
            Gigi's Playhouse "I Have A Voice" Gala
            <div className="underline" />
          </h3>
          <h4>2-27-2017</h4>
          <div className="column left">
            <a
              href="http://wgntv.com/2017/02/27/midday-fix-gigis-playhouse-i-have-a-voice-gala-details/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={images.pressImages.gigi_play} alt="Gigi's Playhouse" />
            </a>
          </div>
          <div className="column right">
            <p>
              NFLPA Chicago Chapter and RPFPC members Tom Serpento, Brent Novoselsky and Oliver
              Gibson stopped by WGN to share how they are supporting
              <a href="https://gigisplayhouse.org/">Gigi's Playhouse</a>, the ONLY nationwide
              network of Down syndrome achievement centers; changing lives through free,
              results-driven programs for individuals of all ages, families and communities.
            </p>
            <a
              href="http://wgntv.com/2017/02/27/midday-fix-gigis-playhouse-i-have-a-voice-gala-details/"
              target="_blank"
              rel="noopener noreferrer"
              className="button"
            >
              FULL ARTICLE
            </a>
          </div>
        </div>
        <div className="story section" id="defender">
          <h3>
            Chicago Defender
            <div className="underline" />
          </h3>
          <h4>5-29-2015</h4>
          <div className="column left">
            <a
              href="http://chicagodefender.com/2015/05/29/american-heart-association-opens-hearts-to-save-lives/?utm_source=Sailthru&utm_medium=email&utm_term=Chicago+Defender+Subscribers&utm_campaign=Chicago+Defender+Daily+Dynamic+-+Morning+2015-05-30&omcamp=es-cd-nl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={images.pressImages.Chicago_Defender} alt="Chicago Defender" />
            </a>
          </div>
          <div className="column right">
            <p>
              NFLPA Chicago Chapter and RPFPC Vice President Reggie Smith delivered the keynote
              speech at the American Heart Association's Open Your Heart event at the Silversmith
              Hotel, where he shared his personal experience with heart disease.
            </p>
            <a
              href="http://chicagodefender.com/2015/05/29/american-heart-association-opens-hearts-to-save-lives/?utm_source=Sailthru&utm_medium=email&utm_term=Chicago+Defender+Subscribers&utm_campaign=Chicago+Defender+Daily+Dynamic+-+Morning+2015-05-30&omcamp=es-cd-nl"
              target="_blank"
              rel="noopener noreferrer"
              className="button"
            >
              FULL ARTICLE
            </a>
          </div>
        </div>
        <div className="story section" id="morning">
          <h3>
            You &amp; Me This Morning
            <div className="underline" />
          </h3>
          <h4>5-12-2015</h4>
          <div className="column left">
            <a href="http://ow.ly/N0nIr" target="_blank" rel="noopener noreferrer">
              <img src={images.pressImages.You_Me_This_Morning1} alt="You and Me This Morning" />
            </a>
          </div>
          <div className="column right">
            <p>
              NFLPA Chicago Chapter and RPFPC Vice President Reggie Smith joined Dr. Jessica Sheperd
              at WCIU's You &amp; Me This Morning show to chat about heart disease awareness ahead
              of Reggie's keynote speech at the American Heart Association's Open Your Heart event
              on May 15.
            </p>
            <a
              href="http://ow.ly/N0nIr"
              target="_blank"
              rel="noopener noreferrer"
              className="button"
            >
              FULL VIDEO
            </a>
          </div>
        </div>
        <div className="story section" id="windy">
          <h3>
            Windy City Live
            <div className="underline" />
          </h3>
          <h4>4-30-2015</h4>
          <div className="column left">
            <img src={images.pressImages.Windy_City_Live} alt="Windy City Live" />
          </div>
          <div className="column right">
            <p>
              NFLPA Chicago Chapter and RPFPC member Desmond Clark stopped by ABC-7's Windy City
              Live on NFL Draft Day to share his own Draft experience and discuss the week-long
              festivities in Chicago.
            </p>
          </div>
        </div>
        <div className="story section" id="morning2">
          <h3>
            You &amp; Me This Morning
            <div className="underline" />
          </h3>
          <h4>4-30-2015</h4>
          <div className="column left">
            <a
              href="http://www.wciu.com/videos/youandme/nfl-draft-process-101"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={images.pressImages.You_Me_This_Morning2} alt="You and Me This Morning" />
            </a>
          </div>
          <div className="column right">
            <p>
              NFLPA Chicago Chapter and RPFPC President Brent Novoselsky returned to WCIU's You
              &amp; Me This Morning show to chat about the NFL Draft process and share his own
              personal Draft Day experience.
            </p>
            <a
              href="http://www.wciu.com/videos/youandme/nfl-draft-process-101"
              target="_blank"
              rel="noopener noreferrer"
              className="button"
            >
              FULL VIDEO
            </a>
          </div>
        </div>
        <div className="story section" id="morning3">
          <h3>
            You &amp; Me This Morning
            <div className="underline" />
          </h3>
          <h4>4-14-2015</h4>
          <div className="column left">
            <a href="http://ow.ly/LEbPl" target="_blank" rel="noopener noreferrer">
              <img src={images.pressImages.You_Me_This_Morning3} alt="You and Me This Morning" />
            </a>
          </div>
          <div className="column right">
            <p>
              NFLPA Chicago Chapter and RPFPC President Brent Novoselsky joined Melissa Forman and
              Jeanne Sparrow on WCIU's You &amp; Me This Morning show to discuss the organization's
              2015 NFL Draft Week events in Chicago.
            </p>
            <a
              href="http://ow.ly/LEbPl"
              target="_blank"
              rel="noopener noreferrer"
              className="button"
            >
              FULL VIDEO
            </a>
          </div>
        </div>
        <div className="story section" id="sports">
          <h3>
            Sports Edition
            <div className="underline" />
          </h3>
          <h4>4-11-2015</h4>
          <div className="column left">
            <a
              href="http://wciu.com/videos/cpssports/cps-sports-edition-nfl-draft"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={images.pressImages.Sports_Edition} alt="Sports Edition" />
            </a>
          </div>
          <div className="column right">
            <p>
              NFLPA Chicago Chapter and RPFPC President Brent Novoselsky and Treasurer Shafer Suggs
              joined Kenny McReynolds on WCIU's Sports Edition to talk about the organization's 2015
              NFL Draft Week events in Chicago.
            </p>
            <a
              href="http://wciu.com/videos/cpssports/cps-sports-edition-nfl-draft"
              target="_blank"
              rel="noopener noreferrer"
              className="button"
            >
              FULL VIDEO
            </a>
          </div>
        </div>
        <div className="story section" id="comcast">
          <h3>
            Comcast SportsNet Chicago
            <div className="underline" />
          </h3>
          <h4>7-21-2014</h4>
          <div className="column left">
            <a
              href="http://www.csnchicago.com/bears/85-bears-reunite-golf-course"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={images.pressImages.Comcast_SportsNet_Chicago}
                alt="Comcast Sportsnet Chicago"
              />
            </a>
          </div>
          <div className="column right">
            <p>
              CSN Chicago caught up with Hall of Famer Dan Hampton &amp; his fellow '85 Chicago
              Bears teammates on site at the 16th Annual Celebrity Golf Outing.
            </p>
            <a
              href="http://www.csnchicago.com/bears/85-bears-reunite-golf-course"
              target="_blank"
              rel="noopener noreferrer"
              className="button"
            >
              FULL VIDEO
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default Press
